import React from 'react';

const useHandleSave = (setShowError) => {
    return (isValid, handleSubmit) => {
        if (!isValid) {
            setShowError(true);
        } else {
            setShowError(false);
            handleSubmit();
        }
    };
};

export default useHandleSave;
